module.exports = __webpack_public_path__ + "img/xiantou.fa30b1f8.png";